document.addEventListener('DOMContentLoaded', function () {
    // Try multiple possible IDs for the container
    const possibleContainerIDs = [
        'categoryContainer',
        'category-container',
        'news-categories',
        'category-scroll-container'
    ];
    
    let categoryContainer = null;
    for (const id of possibleContainerIDs) {
        categoryContainer = document.getElementById(id);
        if (categoryContainer) break;
    }
    
    // Also try finding by class if ID not found
    if (!categoryContainer) {
        categoryContainer = document.querySelector('.category-scroll-container');
    }
    
    // Silent exit if no category container found - this is normal for pages without news categories
    if (!categoryContainer) {
        return;
    }
    
    // Try multiple possible IDs for scroll buttons  
    const possibleLeftButtonIDs = ['scrollLeft', 'scroll-left', 'categoryScrollLeft'];
    const possibleRightButtonIDs = ['scrollRight', 'scroll-right', 'categoryScrollRight'];
    
    let scrollLeftBtn = null;
    let scrollRightBtn = null;
    
    for (const id of possibleLeftButtonIDs) {
        scrollLeftBtn = document.getElementById(id);
        if (scrollLeftBtn) break;
    }
    
    for (const id of possibleRightButtonIDs) {
        scrollRightBtn = document.getElementById(id);
        if (scrollRightBtn) break;
    }
    
    // Also try finding by class
    if (!scrollLeftBtn) {
        scrollLeftBtn = document.querySelector('.scroll-indicator.left, .scroll-left');
    }
    if (!scrollRightBtn) {
        scrollRightBtn = document.querySelector('.scroll-indicator.right, .scroll-right');
    }
    
    const categoryButtons = document.querySelectorAll('.category-btn, .btn[data-category]');
    const selectedCategoryDisplay = document.getElementById('selectedCategory') || 
                                   document.querySelector('.selected-category');

    // Silent exit if no category buttons found
    if (categoryButtons.length === 0) {
        return;
    }

    // Only log success message in debug mode (when URL contains debug parameter)
    const isDebugMode = window.location.search.includes('debug=true') || 
                       window.location.hostname === 'localhost' ||
                       window.location.hostname === '127.0.0.1';
    
    if (isDebugMode) {
        console.log('✅ News category scroll initialized successfully');
        console.log('Found elements:', {
            container: !!categoryContainer,
            leftButton: !!scrollLeftBtn,
            rightButton: !!scrollRightBtn,
            buttons: categoryButtons.length,
            display: !!selectedCategoryDisplay
        });
    }

    // Scroll amount per click
    const scrollAmount = 200;

    // Update scroll indicators visibility
    function updateScrollIndicators() {
        if (!categoryContainer) return;
        
        const { scrollLeft, scrollWidth, clientWidth } = categoryContainer;
        const canScrollLeft = scrollLeft > 0;
        const canScrollRight = scrollLeft < scrollWidth - clientWidth - 1;

        if (scrollLeftBtn) {
            scrollLeftBtn.classList.toggle('hidden', !canScrollLeft);
            scrollLeftBtn.style.display = canScrollLeft ? 'flex' : 'none';
        }
        
        if (scrollRightBtn) {
            scrollRightBtn.classList.toggle('hidden', !canScrollRight);
            scrollRightBtn.style.display = canScrollRight ? 'flex' : 'none';
        }
    }

    // Scroll functions
    function scrollLeftAction() {
        if (!categoryContainer) return;
        
        categoryContainer.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
    }

    function scrollRightAction() {
        if (!categoryContainer) return;
        
        categoryContainer.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }

    // Event listeners for scroll buttons
    if (scrollLeftBtn) {
        scrollLeftBtn.addEventListener('click', scrollLeftAction);
    }
    
    if (scrollRightBtn) {
        scrollRightBtn.addEventListener('click', scrollRightAction);
    }

    // Update indicators on scroll
    categoryContainer.addEventListener('scroll', updateScrollIndicators);

    // Update indicators on window resize
    window.addEventListener('resize', updateScrollIndicators);

    // Initialize scroll indicators
    updateScrollIndicators();

    // Category button functionality
    categoryButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // Remove active class from all buttons
            categoryButtons.forEach(btn => btn.classList.remove('active'));

            // Add active class to clicked button
            this.classList.add('active');

            // Update display if element exists
            if (selectedCategoryDisplay) {
                const categoryText = this.textContent.replace(/\d+/g, '').trim();
                selectedCategoryDisplay.textContent = categoryText;
            }

            // Scroll the active button into view if needed
            const containerRect = categoryContainer.getBoundingClientRect();
            const buttonRect = this.getBoundingClientRect();

            if (buttonRect.left < containerRect.left) {
                categoryContainer.scrollBy({
                    left: buttonRect.left - containerRect.left - 20,
                    behavior: 'smooth'
                });
            } else if (buttonRect.right > containerRect.right) {
                categoryContainer.scrollBy({
                    left: buttonRect.right - containerRect.right + 20,
                    behavior: 'smooth'
                });
            }

            // Trigger custom event for content filtering
            const categoryChangeEvent = new CustomEvent('categoryChange', {
                detail: {
                    category: this.dataset.category,
                    categoryText: this.textContent.replace(/\d+/g, '').trim()
                }
            });
            document.dispatchEvent(categoryChangeEvent);

            // Only log in debug mode
            if (isDebugMode) {
                console.log('Selected category:', this.dataset.category);
            }
        });
    });

    // Touch/swipe support for mobile
    let startX = 0;
    let scrollLeftStart = 0;
    let isDragging = false;

    categoryContainer.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        scrollLeftStart = this.scrollLeft;
        isDragging = true;
    });

    categoryContainer.addEventListener('touchmove', function (e) {
        if (!isDragging) return;

        const currentX = e.touches[0].clientX;
        const diff = startX - currentX;
        this.scrollLeft = scrollLeftStart + diff;
    });

    categoryContainer.addEventListener('touchend', function () {
        isDragging = false;
    });

    // Keyboard navigation
    categoryContainer.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            scrollLeftAction();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            scrollRightAction();
        }
    });

    // Auto-scroll to active category on page load
    setTimeout(() => {
        const activeButton = document.querySelector('.category-btn.active');
        if (activeButton && categoryContainer) {
            const containerRect = categoryContainer.getBoundingClientRect();
            const buttonRect = activeButton.getBoundingClientRect();

            if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
                activeButton.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        }
    }, 100);
});

// Global API - always available
window.NewsCategoryScroll = {
    // Check if the module is initialized on current page
    isInitialized: function() {
        return !!document.getElementById('categoryContainer') || 
               !!document.querySelector('.category-scroll-container');
    },
    
    // Function to programmatically set active category
    setActiveCategory: function(categoryValue) {
        if (!this.isInitialized()) return false;
        
        const button = document.querySelector(`[data-category="${categoryValue}"]`);
        if (button) {
            button.click();
            return true;
        }
        return false;
    },
    
    // Function to get current active category
    getActiveCategory: function() {
        if (!this.isInitialized()) return null;
        
        const activeButton = document.querySelector('.category-btn.active');
        return activeButton ? activeButton.dataset.category : null;
    },
    
    // Get all available categories
    getAvailableCategories: function() {
        if (!this.isInitialized()) return [];
        
        const buttons = document.querySelectorAll('[data-category]');
        return Array.from(buttons).map(btn => ({
            value: btn.dataset.category,
            text: btn.textContent.replace(/\d+/g, '').trim()
        }));
    },
    
    // Enable debug mode
    enableDebug: function() {
        console.log('News Category Scroll Debug Info:');
        console.log('- Initialized:', this.isInitialized());
        console.log('- Active category:', this.getActiveCategory());
        console.log('- Available categories:', this.getAvailableCategories());
    }
};